import React from "react";

interface IBoxWithIconProps {
	icon: React.ReactNode;
	title: string;
	children: React.ReactNode;
	backgroundColor?: string;
}

const BoxWithIcon: React.FC<IBoxWithIconProps> = ({
	icon,
	title,
	children,
	backgroundColor,
}) => {
	return (
		<div
			className={`relative border w-full p-4 drop-shadow-md ${backgroundColor ?? "bg-white"}`}
		>
			{/* Icon in the top-left corner */}
			<div className="absolute -top-4 left-6 bg-gradient-to-r from-sky-700 to-sky-900 text-white p-1 px-2 drop-shadow-md">
				<div className="flex items-center justify-start gap-2">
					{icon}
					<span className="font-Poppins font-medium text-sm tracking-wider">
						{title}
					</span>
				</div>
			</div>

			{/* Content of the box */}
			<div className="mt-4">{children}</div>
		</div>
	);
};

export default BoxWithIcon;
